
  window.modal = new function() {
    var _ = this;

    //Initialisation
    _.init = function() {
      _.createEventHandlers();
      if(typeof(redirect_to_cbd)!="undefined"&&redirect_to_cbd){
        _.action.open(undefined);
      }
      const urlParams = new URLSearchParams(window.location.search);
      const referral_code = urlParams.get('referral_code');
      if(referral_code!=""&&referral_code!="null"&&referral_code!=null&&referral_code.substr(0,5)=="TREF-") {
        _.action.referral();
      }
    }

    _.createEventHandlers = function() {
      document.addEventListener('click', function(e) {

        var source;
        if(e.target.matches('[data-modal-action]')) {
          source = e.target;
          e.preventDefault();
        } else if(e.target.closest("[data-modal-action]")){
          source = e.target.closest("[data-modal-action]");
          e.preventDefault();
        } else {
          return;
        }
        
        var element = source;
        var action = element.getAttribute('data-modal-action').split(".");
        console.log(action);
        if(action.length==1) { _.action[action[0]](element); } else { _[action[0]][action[1]](element); }
        return false;
      });
    }

    _.action = new function() {
      var __ = this;
      __.blank = function(element) {
      }
      __.open = function(element) {
        var title = "<h4>Leaving togetherhealth.co.uk</h4>";
        var content = "<p>Currently, our CBD offering is on a separate website with its own basket and checkout process.</p><p>If you are interested in both our CBD and other items from our range, you may wish to finish up your order here on our main website before visiting our CBD site.</p>";
        var actions = "<p><a href='#' data-modal-action='to_cbd' class='button btn'>Continue to CBD site</a> <a href='#' data-modal-action='close' class='button btn btn--secondary'>Stay on our main website</a></p>";
        _.window.init(title,content,actions);
        _.window.show();
      }
      __.close = function(element) {
        _.window.hide();
      }
      __.to_cbd = function(element) {
        element.classList.add("working");
        window.location.href = "https://tinyurl.com/v5de9sa";
      }
      __.referral = function() {
        const urlParams = new URLSearchParams(window.location.search);
        const referral_code = urlParams.get('referral_code');
        if(referral_code!=""&&referral_code!="null"&&referral_code!=null) {
          var title = "<h1>Welcome!</h1>";
          var content = "<p>Together Health provides a wide range of <b>clean</b>, <b>ethically manufactured</b> supplements with <b>no harmful additives</b> to help support your lifestyle.</p><p>You can use the code below to get <b>30% off</b> your first order!</p><p class='centered' data-modal-action='copy_discount_code' data-discount-code='"+referral_code+"'><span class='modal-referral-code--wrapper'><span class='modal--code-block'>"+referral_code+"</span><span class='modal-card--action--wrapper'><svg class='modal-card--action' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='30px' height='30px' viewBox='0 0 30 30' enable-background='new 0 0 30 30' xml:space='preserve'><path fill-rule='evenodd' clip-rule='evenodd' fill='#006E63' d='M22.546,25.139l-0.261,0.261H8.908 c-0.173-0.087-0.26-0.261-0.26-0.434V7.679c0.173-0.174,0.434-0.261,0.608-0.261h12.595c0.261,0,0.521,0.086,0.694,0.261V25.139z M22.285,6.377H8.822c-0.521,0-1.128,0.434-1.216,0.955v18.241c0,0.521,1.216,0.869,1.303,0.955h13.291 c0.694,0,1.389-0.868,1.477-1.477V7.766C23.676,7.158,22.98,6.463,22.285,6.377z M5.868,21.925H5.435 c-0.174-0.088-0.261-0.261-0.261-0.434V4.205c0.173-0.173,0.434-0.261,0.608-0.261h12.595c0.261,0,0.521,0.088,0.694,0.261V4.64 h1.13V4.291c0-0.608-0.694-1.302-1.391-1.389H5.347c-0.52,0-1.128,0.434-1.216,0.956v18.24c0,0.521,1.216,0.87,1.304,0.956h0.434 V21.925z'></path></svg></span></span></p>";
          var actions = "<p class='centered'><a href='#' data-modal-action='close' class='button btn'>Start shopping</a></p>";
          _.window.init(title,content,actions);
          document.querySelector(".modal--card").classList.add("modal-card--centered");
          _.window.show();
          //Auto apply
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function() {};
          xhr.open('GET', '/discount/'+referral_code);
          xhr.send();
        }
      }
      __.copy_discount_code = function(element) {
        var referral_code = element.getAttribute("data-discount-code");
        const el = document.createElement('textarea');
        el.value = referral_code;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        document.querySelector(".modal--card .modal-card--action--wrapper").classList.add("modal-card--action--complete");
        element.classList.add("copied");
      }
    }

    _.window = new function() {
      var __ = this;
      __.init = function(title,content,actions) {
        console.log(title);
        console.log(content);
        console.log(actions);
        document.querySelector(".modal--card").classList.remove("modal-card--centered");
        document.querySelector(".modal--title").innerHTML = title;
        document.querySelector(".modal--content").innerHTML = content;
        document.querySelector(".modal--actions").innerHTML = actions;
      }
      __.show = function() {
        document.querySelector("body").classList.add("show-modal");
      }
      __.hide = function() {
        document.querySelector("body").classList.remove("show-modal");
      }
    }

  }
  document.addEventListener('DOMContentLoaded', function() {
    modal.init();
  });
